import { render, staticRenderFns } from "./DetailsContact.vue?vue&type=template&id=91e59bca&scoped=true"
import script from "./DetailsContact.vue?vue&type=script&lang=js"
export * from "./DetailsContact.vue?vue&type=script&lang=js"
import style0 from "./DetailsContact.vue?vue&type=style&index=0&id=91e59bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e59bca",
  null
  
)

export default component.exports